import * as React from 'react';
import './index.scss';
import Filter from './filter';
import { Button, Flex, Space, Splitter } from 'antd';
import IssueComponent from './issueComponent';
import Baklog from './backLog/index';

interface SprintComponentProps {
    projectId: string;
    onClickIssue: (e: any) => void;
    showOldSprint?: boolean;
}

const SprintComponent: React.FC<SprintComponentProps> = ({
    projectId,
    showOldSprint,
    onClickIssue
}) => {
    const [open, setOpen] = React.useState(false);
    const [searchValue, setSearchValue] = React.useState<string[]>([]);

    return (
        <>
            <Flex justify='space-between'>
                <Filter projectId={projectId} onSearch={e => setSearchValue(e)} />
                {!showOldSprint && <Button onClick={() => setOpen(true)}>Create Sprint</Button>}
            </Flex>
            <Baklog projectId={projectId}
                isVisible={open}
                onClickIssue={(e) => onClickIssue(e)}
                onClose={() => setOpen(false)}
                onSearch={searchValue}
                showOldSprint={showOldSprint}
            />
        </>
    );
};

export default SprintComponent;
